// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  sentry: {
    dsn: 'https://47d9be1d0df548b9b642d84e0770a3cf@o4504129321500672.ingest.sentry.io/4504252541566976',
    environment: 'qa',
    targets: ['gamegs.exelweb.co.il'],
    // This means % of transactions sent to sentry.
    // Value is between 0 which is send nothing and 1.0 which is send everything.
    rate: 1.0
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
